import { render, staticRenderFns } from "./SidebarLayout.vue?vue&type=template&id=590f6c8e&"
import script from "./SidebarLayout.vue?vue&type=script&lang=js&"
export * from "./SidebarLayout.vue?vue&type=script&lang=js&"
import style0 from "./SidebarLayout.vue?vue&type=style&index=0&id=590f6c8e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports